module.exports = __webpack_public_path__ + "img/currency5.8b4c3e0d.png";